import { useEffect, useState, useCallback } from 'react';
import { useIncomingEmailRepository } from '@ayocore/mailer/client/rpc';
import logger from '@ayocore/platform/common/helpers/logger';
import type { IncomingEmail } from '../../schemas/incoming-email.schema';
import EmailView from './EmailView';

export interface EmailViewerProps {
  /** UUID письма для загрузки и отображения */
  emailUuid: string;
  onRefresh?: () => void;
}

/**
 * EmailViewer — обёртка над EmailView, загружает письмо по UUID и отображает его.
 * Используется в drawer, при переходе по ссылке из CRM и т.п.
 */
const EmailViewer = ({ emailUuid, onRefresh }: EmailViewerProps) => {
  const repository = useIncomingEmailRepository();
  const [email, setEmail] = useState<IncomingEmail | null>(null);
  const [loading, setLoading] = useState(true);

  const loadEmail = useCallback(async () => {
    if (!emailUuid?.trim()) {
      setEmail(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const found = await repository.findById(emailUuid.trim());
      setEmail(found);
    } catch (error) {
      logger.error('[EmailViewer] Не удалось загрузить письмо по uuid', error);
      setEmail(null);
    } finally {
      setLoading(false);
    }
  }, [emailUuid, repository]);

  useEffect(() => {
    loadEmail();
  }, [loadEmail]);

  return <EmailView email={email} loading={loading} onRefresh={onRefresh} />;
};

export default EmailViewer;
